import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { AssetDto, GalleryDto } from '@nusign/picflow-backend-types';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-asset-page-meta',
  templateUrl: './asset-page-meta.component.html',
  styleUrls: ['./asset-page-meta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, SvgComponent, TranslatePipe],
})
export class AssetPageMetaComponent {
  private check = inject(ChangeDetectorRef);
  @Input() asset: AssetDto;
  @Input() gallery: GalleryDto;
  @Input() thumbnailBarOpen: boolean;
  @Input() center: boolean;
  @Input() activeIndex: number;
  @Output() onThumbnailBarOpen = new EventEmitter();

  getNiceName(type: string) {
    const array = this.asset.version_data.asset_name.split('.');
    array.pop();
    const string = array.join('.');
    if (type === 'first') {
      return string.substring(0, string.length - 8);
    }
    return string.substring(string.length - 8);
  }

  onToggle() {
    this.check.detectChanges();
  }
}
